@if (currentSubscription?.status === SubscriptionStatus.Cancelled) {
  <div class="alert alert-warning warning-emphasis p-3">
    <i class="iconoir-warning-triangle"></i>
    <span class="ps-3">
      Subscription plan has been cancelled! You have access until
      {{ currentSubscription?.date_end | date: 'dd MMMM yyyy' }}.</span
    >
  </div>
}
<div class="card shadow auto-height">
  <div class="card-body">
    <div class="row mb-3 align-items-center">
      <div class="col">
        <div class="card-title mb-0">Your plan details</div>
      </div>
      <div class="col-auto ms-auto">
        <button
          id="manageBtn"
          (click)="onManage()"
          [ngClass]="currentSubscription?.status === SubscriptionStatus.Cancelled ? 'disabled' : ''"
          class="btn btn-primary btn-sm">
          Manage
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col mh-100">
        <div class="card border-secondary border-2 h-100">
          <div class="card-body">
            <div class="row align-tems-center gy-3">
              <div
                class="col-auto text-secondary h4 mb-0"
                id="currentPackageTitle">
                {{ currentSubscription?.package?.name }}
              </div>
              <div class="col-auto">
                <div class="badge text-success bg-success">Current Plan</div>
              </div>
              <div class="col-auto ms-sm-auto">
                @if (upgradesAvailable.length && currentSubscription?.status !== SubscriptionStatus.Cancelled) {
                  <button
                    routerLink="upgrade-plan"
                    class="btn btn-secondary btn-sm"
                    id="upgradeBtn">
                    Upgrade to {{ nextUpgradeTitle }}
                  </button>
                }
              </div>
            </div>
            <hr />
            <div class="mb-3">
              <span class="h4">
                {{ currentSubscription?.upcoming_amount | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              </span>
              <span class="text-sm text-muted">
                per {{ currentSubscription?.frequency === SubscriptionFrequency.MONTHLY ? 'month' : 'year' }}
              </span>
            </div>
            <div class="row gy-3 row-cols-lg-2">
              <div class="col">
                <app-info-block
                  bgClass="bg-pays-subtle-gray"
                  label="Start date:"
                  [value]="currentSubscription?.date_start | date: 'dd MMM yyyy'">
                </app-info-block>
              </div>
              <div class="col">
                <app-info-block
                  bgClass="bg-pays-subtle-gray"
                  label="Next payment:"
                  [value]="currentSubscription?.date_next_payment | date: 'dd MMM yyyy' | emptyIndicator">
                </app-info-block>
              </div>
              <div class="col">
                <app-info-block
                  bgClass="bg-pays-subtle-gray"
                  label="Billed:"
                  [value]="currentSubscription?.frequency">
                </app-info-block>
              </div>
              <div class="col">
                <app-info-block
                  bgClass="bg-pays-subtle-gray"
                  label="Upcoming amount:"
                  [value]="currentSubscription?.upcoming_amount | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator">
                </app-info-block>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col mh-100">
        <div class="card border-gray h-100">
          <div class="card-body">
            <div class="card-title">
              <div class="row align-items-center">
                <div class="col">Billing details</div>
                <div class="col-auto">
                  <button
                    (click)="onEditBusiness()"
                    class="btn btn-sm btn-light-on-white text-secondary">
                    <i class="iconoir-edit-pencil"></i> Edit details
                  </button>
                </div>
              </div>
            </div>
            <hr class="my-3" />

            <div class="row gy-3 row-cols-1 row-cols-lg-2">
              <div class="col">
                <app-info-block
                  bgClass="bg-pays-subtle-gray"
                  label="Billing Address:"
                  [showLineBreaks]="true"
                  [value]="
                    businessDetails()?.billing_address ? businessDetails()?.billing_address : businessDetails()?.address
                  ">
                </app-info-block>
              </div>
              <div class="col">
                <app-info-block
                  bgClass="bg-pays-subtle-gray"
                  label="VAT number:"
                  placeholder="No VAT number provided"
                  [showLineBreaks]="true"
                  tooltipText="To ensure your tax invoices are complete and accurate, please take a moment to add your VAT number."
                  tooltipIcon="iconoir-warning-circle"
                  tooltipClass="text-warning"
                  [tooltipDisplay]="!businessDetails()?.vat_num"
                  [value]="businessDetails()?.vat_num">
                </app-info-block>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card shadow">
  <div class="card-body">
    <div class="card-title">Invoices</div>
    <app-table
      [columns]="columns"
      [pageSize]="4"
      class="table-your-plan"
      emptyMessage="Your invoices will appear here."
      [getDataCallback]="getData">
      <ng-template
        #dateCell
        let-value="value">
        {{ value | date: 'dd/MM/yyyy' }}
      </ng-template>
      <ng-template
        #amountCell
        let-value="value">
        {{ value | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
      </ng-template>
      <ng-template
        #actionsCell
        let-row="row">
        <div class="text-center">
          <button
            class="btn-action"
            (click)="onDownloadInvoice(row.id)"
            (keyup)="onDownloadInvoice(row.id)">
            <i class="iconoir-download"></i>
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet></router-outlet>
</div>
